import GameObject from '../GameObject/GameObject';
import AnimationComponent from '../Component/Animation';
import TransformComponent from '../Component/Transform';
import Renderable from '../Component/Renderable';
import Overlay from './UI/Overlay';

export default class Animator extends GameObject {
    protected onCreate(params: any): void {
        this.addComponent(Renderable, params);
        this.addComponent(TransformComponent, params);
        this.addComponent(AnimationComponent, params);

        this.addChild(GameObject.Instantiate(Overlay));
    }
}
